﻿/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class appointmentreference extends IceEntity {
    appointment_key: string = "";
    appt_location: string = "";
    patient_trans_account: string = "";
    appointment_type: IceTypes.appt_type = IceTypes.appt_type.appttypeOther;
    last_name: string = "";
    subject: string = "";
    phone: string = "";
    slot_color: string = "";
    slot_font_color: string = "";

    gettablename(): string {
        return "APPOINTMENT_REFERENCE";
    }
}
